import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ChangePriceStateRequest, PagedPriceShortModel, PriceResourceService, PriceShortModel, SavePriceRequest, SaveResult } from 'hx-services';

@Injectable({providedIn: 'root'})
export class PriceService {

  constructor(
    private priceResourceService: PriceResourceService,
  ) { }

  getPriceList(params: { limit?: number, page?: number, storeProductId?: number, includeDisabled?: boolean }): Promise<PagedPriceShortModel> {
    return firstValueFrom(this.priceResourceService.getPrices(params.includeDisabled, params.limit, params.page, params.storeProductId));
  }

  getPrice(priceId: number): Promise<PriceShortModel> {
    return firstValueFrom(this.priceResourceService.getPriceById(priceId));
  }

  deletePrice(priceId: number): Promise<SaveResult> {
    return firstValueFrom(this.priceResourceService.removePrice(priceId));
  }

  createPrice(body: SavePriceRequest): Promise<SaveResult> {
    return firstValueFrom(this.priceResourceService.insertPrice(body));
  }

  updatePrice(priceId: number, body: SavePriceRequest): Promise<SaveResult> {
    return firstValueFrom(this.priceResourceService.updatePrice(priceId, body));
  }

  changePriceState(priceId: number, body: ChangePriceStateRequest): Promise<SaveResult> {
    return firstValueFrom(this.priceResourceService.changePriceState(priceId, body));
  }
}
